const urls = {
  get_exercise_skill_analysis: '/exercise/skill/get-analysis',
};

export default urls;
